import { IBlock } from 'types/allocationInterfaces'
import colors from 'constants/colors'
import { lightenDarkenColor, roundToDecimal } from 'utils/utils'
import { addWeeks, differenceInDays } from 'date-fns'

/**
 * Generates the style object for a block based on its properties.
 *
 * @param {IBlock} block - The block object containing the properties of the block.
 * @param {number} timeScope - The time scope in months used for calculating the multiplier.
 * @return {Object} The style object with the width, border, color, and borderRadius properties.
 */
export const blockStyle = (block: IBlock, timeScope: number) => {
  let color: string = colors.background
  let textColor: string = colors.description

  if (block.percent === 0) {
    color = colors.gray
  } else if (block.percent < 100) {
    color = colors.orange
  } else if (block.percent < 101) {
    color = colors.red
    textColor = colors.background
  } else if (block.percent > 100) {
    color = colors.purple
    textColor = colors.background
  }

  const multiplier = 100 / differenceInDays(addWeeks(new Date(), timeScope * 4), new Date())

  const style: {
    width: string
    border: string
    color: string
    borderRadius: number
    fontSize: string
    background?: string
    backgroundColor?: string
  } = {
    width: `${roundToDecimal(block.length * multiplier, 5)}%`,
    border: `1px solid ${color}`,
    color: textColor,
    borderRadius: 3,
    fontSize: '1em',
  }

  if (block.verified) {
    style.backgroundColor = lightenDarkenColor(color, 50)
  } else {
    if (block.percent > 0) {
      style.background = `repeating-linear-gradient(
      45deg,
      ${lightenDarkenColor(color, 50)},
      ${lightenDarkenColor(color, 50)} 10px,
      ${lightenDarkenColor(color, 20)} 10px,
      ${lightenDarkenColor(color, 20)} 20px
    )`
    }
  }

  return style
}
